<template>
  <b-container class="page-container" fluid>
    <AccountActivatedForm />
  </b-container>
</template>
<style>

</style>

<script>
import AccountActivatedForm from '@/components/AccountActivatedForm.vue';

export default {
  name: "AccountActivated",
  components: {
    AccountActivatedForm,
  }
};
</script>
